import { render, staticRenderFns } from "./CiSpecsTableRow.vue?vue&type=template&id=298810f1&"
import script from "./CiSpecsTableRow.vue?vue&type=script&lang=js&"
export * from "./CiSpecsTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports